/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ImportScheduleComponent } from "../../components/tools/import-schedule/import-schedule.component";
import { GlobalConstants } from "../../constants/global-constants";
import { ImportScheduleInfo } from "../../models/import-schedule-model";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class ImportScheduleDialog implements PopupDialog {

    create(sysquePopupConfig: SysquePopupConfig): any {
        sysquePopupConfig.component = ImportScheduleComponent;
        sysquePopupConfig.data = new ImportScheduleInfo();
        (sysquePopupConfig.data as ImportScheduleInfo).scheduleName = GlobalConstants.ScheduleButton;
        (sysquePopupConfig.data as ImportScheduleInfo).buttonName = GlobalConstants.ImportButton;
        sysquePopupConfig.width = 493;
        sysquePopupConfig.height = 282;
        sysquePopupConfig.componentTitle = GlobalConstants.IMPORT_SCHEDULE_NAME_DIALOG;
    }
}